import { TablePagination } from '@mui/material';
import { ChangeEvent as ReactChangeEvent, MouseEvent as ReactMouseEvent, useCallback } from 'react';
import { TableInstance } from 'react-table';
import { CustomerManagementGridItem } from 'shared/types/customerManagement';

interface CustomerManagementTablePaginationProps {
  instance: TableInstance<CustomerManagementGridItem>;
}
export function CustomerManagementTablePagination({ instance }: CustomerManagementTablePaginationProps) {
  const {
    state: { pageIndex, pageSize },
    gotoPage,
    setPageSize,
    filteredRows,
  } = instance;
  const handlePageChange = useCallback(
    (_: ReactMouseEvent<HTMLButtonElement, MouseEvent> | null, page: number) => {
      gotoPage(page);
    },
    [gotoPage]
  );

  const handleRowsPerPageChange = useCallback(
    (event: ReactChangeEvent<HTMLInputElement>) => {
      setPageSize(Number(event.target.value));
    },
    [setPageSize]
  );

  return (
    <TablePagination
      component='div'
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
      page={pageIndex}
      rowsPerPageOptions={[15, 25, 50, 100]}
      count={filteredRows.length}
      rowsPerPage={pageSize}
    />
  );
}
